import { render, staticRenderFns } from "./competitivePublicEvent.vue?vue&type=template&id=1e0d8f91&scoped=true"
import script from "./competitivePublicEvent.vue?vue&type=script&lang=js"
export * from "./competitivePublicEvent.vue?vue&type=script&lang=js"
import style0 from "./competitivePublicEvent.vue?vue&type=style&index=0&id=1e0d8f91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0d8f91",
  null
  
)

export default component.exports